class NavigationMenu {
    static pageHasNavigationMenu() {
        return $('.header-nav').length > 0;
        
    }

    static run(){
        if (NavigationMenu.pageHasNavigationMenu()) {
            NavigationMenu.initialize();
        }

    }
    static initialize() {
        NavigationMenu.subMenu();
        NavigationMenu.nav();
        NavigationMenu.navBars();
        NavigationMenu.initScroll();
        NavigationMenu.heightMobile()
        //NavigationMenu.openSubMenu();
        //NavigationMenu.contentMenu();
        $(window).resize(function(){
            NavigationMenu.nav();
            //NavigationMenu.openSubMenu();
            NavigationMenu.heightMobile();
            NavigationMenu.contentMenu();
        });
        $(window).load(function(){
            NavigationMenu.heightMobile();
        });

    }

    static nav(){

        if ($(window).width() > 870) {

            $("body").removeClass("mobile");
            $("body").addClass("desktop");


        }else{
            $("body").removeClass("desktop");
            $("body").addClass("mobile");
        }
    }

    static navBars(){
        var statuss = true;
        $(".bars").on("click",function(){
            if (statuss) {
                $(this).add(".header-nav, .overlay_menu").addClass("open");
                $(".mobile").addClass("noscroll");
                $(".sub-menu").removeClass("open");
                statuss = false;
                NavigationMenu.openSubMenu();
            }else{
                $(this).add(".header-nav, .overlay_menu").removeClass("open");
                $(".mobile").removeClass("noscroll");
                $(".header-nav").removeClass("ov_hidden").removeAttr("style");
                statuss = true;
            }
        });
        NavigationMenu.contentMenu();
    }

    static initScroll(){
        $(window).on("scroll",function(){
            NavigationMenu.verifyScroll();
        });
        $(window).resize(function(){
            setTimeout(function(){
                NavigationMenu.verifyScroll();
            },200);
        });
        setTimeout(function(){
            NavigationMenu.verifyScroll();
        },1700);
    }

    static verifyScroll(){
        var navTop = $(".pos_menu").offset().top;
        //console.log(navTop);
        var scroll_top = $(window).scrollTop();
        var isMobile = $(".mobile").length > 0;
        //console.log(isMobile)

        function setuNav(){

            if (scroll_top > 90 && isMobile) {
                $(".mobile").addClass("show_scroll");
            }else{
                $("body").removeClass("show_scroll");
            }
        }
        setuNav();
        //setTimeout(function(){
            //setuNav();
        //},100);
    }

    static heightMobile(){
        let hMobile = $(window).innerHeight();
        let wMobile = $(window).innerWidth();
        let foot = $("footer").innerHeight();
        let isHome = $(".is-home").length > 0;
        //console.log(isHome)
        if(isHome){
            if(window.matchMedia !== undefined){
                if(window.matchMedia("(max-width: 870px) and (orientation:portrait)").matches){
                    $(".container-body").css("height",(hMobile - foot) + "px");
                }else if(window.matchMedia("(max-width: 870px) and (orientation:landscape)").matches){
                    $(".container-body").css("height",(wMobile - foot) + "px");
                }else{
                    $(".container-body").removeAttr("style");
                }
            }
        }
    }

    static subMenu(){
        $(".header-nav > ul > li").each(function(){
            let sMenu = $(this).children("ul").length > 0;
            let $this = $(this);
            //console.log(sMenu);

            if (sMenu) {
                $this.removeClass("sub-menu");
                $this.addClass("sub-menu");
            }
        });
        
    }

    static openSubMenu(){
        let status = false;
        let statusSubMenu = false;
        $(".sub-menu > a").on("click", function(e){
            e.preventDefault();
            if ($(window).width() < 871){
                if (!status) {
                    $(this).parent().addClass("open");
                    NavigationMenu.contentMenu();
                    status = true;
                }else{
                    $(".sub-menu").removeClass("open");
                    $(".sub-menu >ul >li").removeClass("open");
                    NavigationMenu.contentMenu();
                    status = false;
                }
            }else{
                $(".sub-menu").removeClass("open");
                $(".sub-menu >ul >li").removeClass("open");
            }

        });

        $(".sub-menu >ul >li >a").on("click", function(e){
            e.preventDefault();
            if ($(window).width() < 871){
                $(".sub-menu >ul >li").removeClass("open");
                $(this).parent().addClass("open");
                NavigationMenu.contentMenu();
                // if (!statusSubMenu) {
                //     $(this).parent().addClass("open");
                //     NavigationMenu.contentMenu();
                //     //statusSubMenu = true;
                // }else{
                //     $(".sub-menu >ul >li").removeClass("open");
                //     NavigationMenu.contentMenu();
                //     //statusSubMenu = false;
                // }
            }
        });

        /*
        if ($(window).width() < 871){
            let status = false;
            $(".sub-menu > a").on("click", function(e){
                e.preventDefault();
                if (!status) {
                    $(this).parent().addClass("open");
                    NavigationMenu.contentMenu();
                    status = true;
                }else{
                    $(".sub-menu").removeClass("open");
                    NavigationMenu.contentMenu();
                    status = false;
                }
                console.log(status);
            });
        }else{
            $(".sub-menu").removeClass("open");
        }
        */
    }

    static contentMenu(){
        var hc = $(".header-nav.open ul").height();
        var H = $(window).height();
        //alert(hc + " / " + H);

        if (H > hc) {
            $(".header-nav.open").addClass("tp").height(hc);
            $(".header-nav.open").removeClass("ov_hidden");

        }else{
            $(".header-nav.open").removeClass("tp").height(H);
            $(".header-nav.open").addClass("ov_hidden");
        }
    }

}
export {NavigationMenu};